module.exports = __webpack_public_path__ + "img/antes_despues_224.2a02ef77.png";